<template>
  <div>
    <b-container>
      <b-row :key="index" v-for="(row, index) in rows">
        <b-col :key="image.image_id" v-for="image in row">{{image.image_name}}</b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "ImageSelector",
  props: {
    images: Array,
  },
  data() {
    return {
      imagesPerRow: 3,
      rows: [],
      imagesLoaded: false,
    };
  },
  //   computed: {
  //     valueComputed: {
  //       get: function () {
  //         return this.value;
  //       },
  //       set: function (val) {
  //         this.valueData = val;
  //       },
  //     },
  //   },
  //   methods: {},
  mounted() {
    // Sort images

    var tempArray = [];
    // var tempArrayIndex = 0;

    // loop through all images returned and construct rows
    var i;
    for (i = 0; i < this.images.length; i++) {
      // get current image
      var image = this.images[i];

      // if tempArray is full, push it into
      // imageRows
      if (i % this.imagesPerRow == 0 && i > 0) {
        this.rows.push(tempArray);
        tempArray = [image];

        // else if this is the last image we got back
        // push into the temp array and push that into imageRows
      } else if (i == this.images.length - 1) {
        tempArray.push(image);
        this.rows.push(tempArray);

        // else push image into temp array
      } else {
        tempArray.push(image);
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
